/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Faq_TitleInputs */

const en_road_dude_faq_title = /** @type {(inputs: Road_Dude_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions from the road`)
};

const zh_road_dude_faq_title = /** @type {(inputs: Road_Dude_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`常见问题`)
};

/**
* | output |
* | --- |
* | "Questions from the road" |
*
* @param {Road_Dude_Faq_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_faq_title = /** @type {((inputs?: Road_Dude_Faq_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Faq_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_faq_title(inputs)
	return zh_road_dude_faq_title(inputs)
});
export { road_dude_faq_title as "road_dude.faq.title" }